<template lang='pug'>
  UsersList(:title='title' v-if="$store.state.dataUsers.role=='super_user'")
  AdminBuList(:title='title' v-else-if="$store.state.dataUsers.role=='admin'")
</template>

<script>
import UsersList from "../components/UsersList.vue";
import AdminBuList from "../components/AdminBuList.vue";
export default {
  name: "Users",
  components: {
    UsersList,
    AdminBuList
  },
  data: () => ({
    title: "Management Account"
  }),
};
</script>

<style>
.v-main__wrap{
  background: #F3F3F4;
}

.v-application .blue {
  background-color: #01C8F1!important;
  border-color: #01C8F1!important;
}
</style>
